export default __webpack_public_path__ + "static/photoelectric7-fe46e52076532b44c82400dfd4539218.png";